import { apiClient } from './client';
import type { ApiResponse } from '../types/api';
import type {
  GenerateChecklistRequest,
  GenerateChecklistResponse,
  SubmitChecklistRequest,
  ChecklistResult,
  CooldownStatus,
  TriggerCooldownRequest,
  EmergencyBypassRequest,
  CompleteActivityRequest,
  CompleteActivityResponse,
} from '../types/checklist';

export const checklistApi = {
  generateChecklist: (data: GenerateChecklistRequest): Promise<ApiResponse<GenerateChecklistResponse>> =>
    apiClient.post('/checklist/generate', data),

  submitChecklist: (data: SubmitChecklistRequest): Promise<ApiResponse<ChecklistResult>> =>
    apiClient.post('/checklist/submit', data),

  getChecklistResult: (id: number): Promise<ApiResponse<ChecklistResult>> =>
    apiClient.get(`/checklist/${id}`),

  getChecklistHistory: (params?: { page?: number; page_size?: number }): Promise<ApiResponse<ChecklistResult[]>> =>
    apiClient.get('/checklist/history', { params }),

  getCooldownStatus: (): Promise<ApiResponse<CooldownStatus>> =>
    apiClient.get('/cooldown/status'),

  triggerCooldown: (data: TriggerCooldownRequest): Promise<ApiResponse<CooldownStatus>> =>
    apiClient.post('/cooldown/trigger', data),

  emergencyBypass: (data: EmergencyBypassRequest): Promise<ApiResponse<void>> =>
    apiClient.post('/cooldown/bypass', data),

  endCooldown: (): Promise<ApiResponse<void>> =>
    apiClient.post('/cooldown/end'),

  linkChecklistToTrade: (checklistId: number, tradeId: number): Promise<ApiResponse<void>> =>
    apiClient.post(`/checklist/${checklistId}/link`, { trade_id: tradeId }),

  completeActivity: (data: CompleteActivityRequest): Promise<ApiResponse<CompleteActivityResponse>> =>
    apiClient.post('/cooldown/activity/complete', data),
};
